import { useMemo } from 'react';

import { useOperations } from './useOperations';

export function useIsToolsReadOnly() {
  const { canUser } = useOperations();

  return useMemo(() => {
    // User can manage tools if they have ANY of these permissions
    const canManageAnyTools = canUser(['manage_ocp_tools', 'manage_thirdparty_tools']);
    return !canManageAnyTools;
  }, [canUser]);
}
